import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { getActivities } from '../../services/associate/associateService';
import ActivityItem from '../Common/ActivityItem/ActivityItem';
import styles from './LiveFeedActivities.module.css';
import { useHistory } from 'react-router-dom';
import EmptyActivity from '../Common/EmptyActivity/EmptyActivity';
import ActivityItemSkeleton from '../Common/ActivityItem/ActivityItemSkeleton';
import { WelletContext } from '../../context/WelletContext';

const LiveFeedActivities = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem('language') || 'es';
  const welletContext = useContext(WelletContext);
  const history = useHistory();

  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchActivities();
  }, []);

  const fetchActivities = async (page = 1, append = false) => {
    try {
      setLoading(true);
      const response = await getActivities(welletContext, page, 7);

      if (append) {
        setActivities((prev) => [...prev, ...response.items]);
      } else {
        setActivities(response.items);
      }

      setError(null);
    } catch (err) {
      setError(t('common.errorLoadingData'));
      console.error('Error fetching activities:', err);
    } finally {
      setLoading(false);
    }
  };


  if (activities.length === 0) {
    return null;
  }

  return (
    <>
      {loading ? (
        <div className="mt-3">
          <ActivityItemSkeleton />
          <ActivityItemSkeleton />
          <ActivityItemSkeleton borderBottom={false} />
        </div>
      ) : error ? (
        <div className={styles.error}>{error}</div>
      ) : (
        <>
          <div className="mt-2">
            <div className="fw-700 text-lighter-gray mt-5">{t('yourLastActivity')}</div>
            {activities.length > 0 && (
              activities.map((activity, index) => (
                <div key={index} className="border-top">
                  <ActivityItem activity={activity} language={language} />
                </div>
              ))
            )}
          </div>

           {activities.length > 0 && (
            <div className="mt-2">
              <div
                className="account-button w-100 fw-600"
                onClick={() => history.push('/all-activities')}
              >
                {t('showAllActivities')}
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};


export default LiveFeedActivities;
